// Anonymous site events for the gift-ribbon funnel (6.10.2026): no login,
// no PII, one random id per device in localStorage (shared with the daily
// game id so the two funnels can be joined later). Rows land in
// site_events and feed the 09:00 report (migration 0047).
import { supabase } from "./supabase";

export type SiteEvent =
  | "ribbon_click" | "gift_view" | "gift_cta" | "b_view" | "b_cta"
  | "pick_view" | "pick_choose" | "pick_login" | "pick_gate" | "pick_taste" | "about_view"
  | "b2_view" | "b2_cta" | "b2_video";

function anonId(): string {
  try {
    const k = "ei_lion_id";
    let v = window.localStorage.getItem(k);
    if (!v) {
      v = Math.random().toString(36).slice(2) + Date.now().toString(36);
      window.localStorage.setItem(k, v);
    }
    return v;
  } catch {
    return "nols";
  }
}

function sourceTag(): string | null {
  try {
    const q = new URLSearchParams(window.location.search);
    const s = q.get("s") || q.get("utm_source");
    if (s) {
      window.localStorage.setItem("ei_site_src", s);
      return s;
    }
    return window.localStorage.getItem("ei_site_src");
  } catch {
    return null;
  }
}

export function logSiteEvent(event: SiteEvent) {
  try {
    let ref: string | null = null;
    try {
      ref = document.referrer ? new URL(document.referrer).host : null;
    } catch {}
    // supabase-js builders are lazy: the request only fires once .then() runs.
    supabase
      .from("site_events")
      .insert({ anon_id: anonId(), event, path: window.location.pathname, src: sourceTag(), ref })
      .then(
        () => {},
        () => {}
      );
  } catch {}
}
